/**
 * Festival inventory — shared across years (not year-scoped).
 * Physical stock: loaner tutus live in `costume-inventory`;
 * Becoming loaners + bin supplies live here.
 */

export { IABF_FESTIVAL_INVENTORY_COLLECTION } from './iabf-event'

export const INVENTORY_CATEGORIES = [
  { id: 'supply', label: 'Festival supplies' },
  { id: 'becoming', label: 'Becoming costumes' },
  { id: 'tutu', label: 'Tutus' }
]

export const BECOMING_SIZES = ['T', 'SA', 'MA', 'LA', 'XLA']

export const BECOMING_KINDS = [
  { id: 'skirt', label: 'Blue flowing skirt' },
  { id: 'crop', label: 'Crop top' }
]

/** 15 plastic bins. Labels from Aug 2026 packing notes. */
export const INVENTORY_BOXES = [
  { id: 1, label: '' },
  { id: 2, label: 'Awards & competition' },
  { id: 3, label: 'Painting Room - has extra space' },
  { id: 4, label: 'Photo / outdoor' },
  { id: 5, label: 'Theater' },
  { id: 6, label: 'Dancer items & sale' },
  { id: 7, label: 'Free' },
  { id: 8, label: 'Merch' },
  { id: 9, label: 'Tutus' },
  { id: 10, label: 'Tutus' },
  { id: 11, label: 'Tutus' },
  { id: 12, label: 'Tutus' },
  { id: 13, label: 'Costume/Prop Closet' },
  { id: 14, label: 'Pointe shoe keychains' },
  { id: 15, label: 'Supplies' }
]

export function boxLabel (boxId) {
  const b = INVENTORY_BOXES.find(x => x.id === Number(boxId))
  if (!b) {
    return boxId ? ('Box ' + boxId) : 'Unboxed'
  }
  const name = b.label ? ('Box ' + b.id + ' — ' + b.label) : ('Box ' + b.id)
  if (b.hasSpace) {
    return name + ' (has space)'
  }
  return name
}

/**
 * Seed rows from handwritten packing notes (photos IMG_7695–7699).
 * qty null = listed without a count.
 */
export const SUPPLY_SEED_ITEMS = [
  // Box 1 — Stage area
  { box: 1, name: 'JBL Bluetooth speaker', qty: 3 },
  { box: 1, name: 'Ziploc of USB-C cord & plug', qty: 2, notes: 'For painting room at ACA' },
  { box: 1, name: 'Pivot tool', qty: 1 },
  { box: 1, name: 'Barre tools', qty: 11, notes: 'Distribute 1 per room: theater, studio, painting, gallery' },
  { box: 1, name: 'Bag of extra barre tools & screws', qty: 1 },
  { box: 1, name: 'USB-C to HDMI', qty: 3 },
  { box: 1, name: 'Big-to-little headphone adapter', qty: 1 },
  { box: 1, name: 'Lightning to Lightning cable', qty: 2 },
  { box: 1, name: 'Velcro zip ties', qty: null, notes: 'For umbrellas & other' },
  { box: 1, name: 'Electrical tape', qty: 1 },
  { box: 1, name: 'Long knob-head screws', qty: 2 },
  { box: 1, name: 'Extra screws + washer', qty: null, notes: 'Probably for mirrors' },
  { box: 1, name: 'Sharpie', qty: 1 },
  { box: 1, name: 'Headphone to Lightning adapter', qty: 1 },

  // Box 2 — Awards & competition
  { box: 2, name: 'Black velvet cover cloth', qty: 1 },
  { box: 2, name: 'Hexagon display boxes', qty: 6 },
  { box: 2, name: 'Plastic box / paper display stands', qty: 6 },
  { box: 2, name: 'Square display blocks', qty: 6 },
  { box: 2, name: 'Medal display stands', qty: 1, notes: 'One box of stands' },
  { box: 2, name: 'Mini Polaroid camera', qty: 1, notes: 'For pics during banquet' },

  // Box 3 — not full (therabands / mats / speaker)
  { box: 3, name: 'Basket of therabands', qty: 1 },
  { box: 3, name: 'Basket of massage balls', qty: 1 },
  { box: 3, name: 'JBL speaker', qty: 1 },
  { box: 3, name: 'USB-C cable + plug', qty: 1 },
  { box: 3, name: 'Yoga mats', qty: 5 },

  // Box 15 — Supplies (includes items moved out of box 3)
  { box: 15, name: 'Bag of cables and tools', qty: 1, notes: 'Moved from box 3' },
  { box: 15, name: 'Bag of extra floor blocks', qty: 1, notes: 'Moved from box 3' },
  { box: 15, name: 'Scissors', qty: 1 },

  // Box 4 — Photo / outdoor
  { box: 4, name: 'Umbrellas', qty: 10 },
  { box: 4, name: 'Photo equipment', qty: null },
  { box: 4, name: 'Water bags', qty: null },
  { box: 4, name: 'Grey curtain', qty: 2 },
  { box: 4, name: 'Photo posing cube', qty: 1 },
  { box: 4, name: 'Fake flowers', qty: null },
  { box: 4, name: 'Red carpet stand', qty: 1, notes: 'Smaller one' },
  { box: 4, name: 'Rope', qty: 2, notes: 'Misc supplies' },

  // Box 5 — Theater
  { box: 5, name: 'Candles & batteries', qty: null },
  { box: 5, name: 'Cleaning wipes', qty: null },
  { box: 5, name: 'iPad stand', qty: 1 },
  { box: 5, name: 'Steamer', qty: 1 },
  { box: 5, name: 'Floor / money tape', qty: null },

  // Box 6 — Dancer items & sale
  { box: 6, name: 'Cups — dancer items for sale', qty: null },
  { box: 6, name: 'Tutu bags (Stanger’s & others)', qty: null },
  { box: 6, name: '$5 vintage pins for sale', qty: null },
  { box: 6, name: 'Hairclips (free)', qty: null },
  { box: 6, name: 'Fake eyelashes (free)', qty: null },
  { box: 6, name: 'Book / magazine display stand', qty: 1 },
  { box: 6, name: 'Hairdryers', qty: 15 },
  { box: 6, name: 'Yellow two-organizer', qty: 1 }
]

export function becomingItemName (kind, size) {
  const k = BECOMING_KINDS.find(x => x.id === kind)
  const label = k ? k.label : kind
  return size ? (label + ' — ' + size) : label
}

/** Plastic bins labeled for loaner tutus. */
export const TUTU_BOX_IDS = [9, 10, 11, 12]

/** Box 13 is the live costume/prop closet — not a typed supply list. */
export const CLOSET_BOX_ID = 13

export function isCostumeCheckedIn (item) {
  return !!(item && item.storageStatus === 'in' && item.storageBox)
}
